/* eslint-disable max-len */
/* eslint-disable @angular-eslint/no-output-on-prefix */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @angular-eslint/no-output-rename */
/* eslint-disable @angular-eslint/no-input-rename */
import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ImagesManagementService } from '../../services/images-management.service';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'app-profile-image-item',
  templateUrl: 'profile-image-item.html',
  styleUrls: ['profile-image-item.scss'],
  standalone: false
})
export class ProfileImageItemComponent implements OnInit, OnDestroy, OnChanges {
  @Input('profile') profile: any;
  @Input('kioskCheck') kioskCheck: any;
  @Input('isImageService') isImageService?: boolean = true;

  hasImage = false;
  imageUrl: string;
  avatarName: string;
  loaded = false;
  
  // Prevent infinite loading
  private imageLoaded = false;
  private currentImageUrl: string;
  private currentProfileId: string;

  constructor(
    private images: ImagesManagementService,
    private auth: AuthService,
    private utils: UtilsService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    console.log('ProfileImageItem ngOnInit called for profile:', this.profile?.username);
    this.initializeProfile();
    // Only load if profile is already available and hasn't been loaded yet
    if (this.hasValidImageData() && !this.imageLoaded) {
      this.loadImageOnce();
    } else if (this.profile) {
      // Profile exists but no image - show fallback immediately
      this.loaded = true;
      this.cdr.detectChanges();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('ProfileImageItem ngOnChanges called');
    
    if (changes.profile) {
      // Small delay to ensure data is loaded
      setTimeout(() => {
        // Check if we now have valid image data (even if we didn't before)
        if (this.profile && this.hasValidImageData()) {
          const newProfileId = this.getProfileId();
          const newImageUrl = this.getImageUrl();
          
          // Load if this is the first time we have valid data OR if the data actually changed
          if (!this.imageLoaded || newProfileId !== this.currentProfileId || newImageUrl !== this.currentImageUrl) {
            console.log('Profile changed with valid image data, loading image');
            this.imageLoaded = false;
            this.currentProfileId = newProfileId;
            this.currentImageUrl = newImageUrl;
            this.initializeProfile();
            this.loadImageOnce();
          } else {
            console.log('Profile change detected but no actual difference, skipping reload');
          }
        } else if (this.profile && !this.hasValidImageData()) {
          // Profile exists but no image data - show fallback
          console.log('Profile exists but no image data, showing fallback');
          this.hasImage = false;
          this.loaded = true;
          this.initializeProfile();
        }
      }, 10);
    }
  }

  private hasValidImageData(): boolean {
    return !!(this.profile && (
      (this.profile.profilePhoto && this.profile.profilePhoto[0]) ||
      this.profile.logoFile ||
      this.profile.logoImage
    ));
  }

  private getProfileId(): string {
    return this.profile?.id || this.profile?.objectID || this.profile?.username || 'unknown';
  }

  private getImageUrl(): string {
    return this.profile?.profilePhoto?.[0]?.imageURL || 
           this.profile?.logoFile || 
           this.profile?.logoImage || 
           '';
  }

  private initializeProfile() {
    if (this.profile) {
      if (this.profile.username && !this.profile.avatarName) {
        this.profile.avatarName = this.auth.createAvatarName(this.profile.username);
      }
      if (this.profile.avatarName && !this.profile.color) {
        this.profile.color = this.utils.avatarColor(this.profile.avatarName);
      }
    }
  }

  private loadImageOnce() {
    if (this.imageLoaded) {
      console.log('Image already loaded, skipping');
      return;
    }

    if (!this.hasValidImageData()) {
      console.log('No valid image data available yet, skipping load');
      return;
    }

    console.log('Loading image for profile:', this.getProfileId());
    this.loadImage();
  }

  loadImage() {
    // Mark as loaded immediately to prevent duplicate calls
    this.imageLoaded = true;

    if (this.profile && this.profile.profilePhoto && this.profile.profilePhoto[0]) {
      console.log('profile item has image: ' + this.getProfileId());
      this.hasImage = true;
      
      if (this.isImageService) {
        this.images.realImageData(this.profile.profilePhoto[0], false).then((data) => {
          if (data) {
            this.imageUrl = data;
            this.loaded = true;
            this.cdr.detectChanges(); // Trigger view update
          } else {
            this.imageUrl = null;
            this.hasImage = false;
            this.loaded = true;
            this.cdr.detectChanges(); // Trigger view update
          }
        }).catch((error) => {
          console.log('error in profile image item: ' + error);
          this.imageUrl = null;
          this.hasImage = false;
          this.loaded = true;
          this.imageLoaded = false; // Allow retry on error
          this.cdr.detectChanges(); // Trigger view update
        });
      } else {
        this.imageUrl = this.profile.profilePhoto[0];
        this.loaded = true;
        this.cdr.detectChanges(); // Trigger view update
      }
    } else {
      console.log('profile item has no image.');
      this.hasImage = false;
      this.loaded = true;
      this.cdr.detectChanges(); // Trigger view update
      
      if (this.profile) {
        if (this.profile.logoFile) {
          this.imageUrl = this.profile.logoFile;
        } else {
          this.imageUrl = this.profile.logoImage;
        }
        this.cdr.detectChanges(); // Trigger view update after setting fallback
      }
    }
  }

  ngOnDestroy() {
    console.log('ProfileImageItem destroyed for profile:', this.getProfileId());
    // Reset flags on destroy
    this.imageLoaded = false;
  }
}